import { css } from '@emotion/core';
import { Theme, useTheme } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import * as React from 'react';

const DEFAULT_SKELETON_COUNT = 5;
const SKELETON_HEIGHT_LARGE = 24;
const SKELETON_HEIGHT_SMALL = 20;

const skeletonStyles = (theme: Theme) => css`
    .profile-preview-skeleton__item {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 12px;
        border-bottom: 1px solid ${theme.palette.divider};

        &:last-child {
            border-bottom: none;
        }
    }
`;

interface ProfilePreviewSkeletonProps {
    count?: number;
}

export const ProfilePreviewSkeleton: React.FC<ProfilePreviewSkeletonProps> = ({ count = DEFAULT_SKELETON_COUNT }) => {
    const theme = useTheme<Theme>();

    const rows = Array.from({ length: count }, (_, i) => (
        <div key={i} className="profile-preview-skeleton__item">
            <Skeleton height={SKELETON_HEIGHT_LARGE} variant="text" width="40%" />
            <Skeleton height={SKELETON_HEIGHT_SMALL} variant="text" width="60%" />
            <Skeleton height={SKELETON_HEIGHT_SMALL} variant="text" width="30%" />
        </div>
    ));

    return (
        <div css={skeletonStyles(theme)}>
            <div className="profile-preview-skeleton__container">{rows}</div>
        </div>
    );
};
